import { useQuery } from '@tanstack/react-query';
import { fanEventsReadMany } from '@zealot/shared/apiClient';
import { useApiClient } from '@/contexts/ApiClientContext';
import { useAuthReady } from '@/hooks/useAuthReady';

const EMPTY_EVENTS: never[] = [];

// gloss
export const useFanEvents = () => {
  const client = useApiClient();
  const { isAuthReady: isReady, fanUserID: userID } = useAuthReady({ requireUserID: false });

  return useQuery({
    queryKey: ['fanEvents', userID],
    queryFn: async () => {
      const response = await fanEventsReadMany({ client });

      if (response.error) {
        throw new Error(response.error.message || 'Failed to fetch events');
      }

      return response.data?.data ?? EMPTY_EVENTS;
    },
    enabled: isReady,
  });
};
